import React from 'react';
import { useStoreState } from 'base/store';
import Tracker from '@base/lib/Tracker';
import Image from '@base/lib/ThemeImage';
import styles from './index.module.less';

const MODULE_ID = 'WEB Top banner';

const TopStripedBanner: React.FC = () => {
    const { topStripedBanner } = useStoreState('persistStore') || {};
    if (!topStripedBanner) {
        return null;
    }

    const {
        bgColor = 'none',
        height = 48,
        image,
        href,
        alt,
        target
    } = topStripedBanner;

    return (
        <Tracker
            data={{
                targetType: 'banner',
                target: href,
                relTarget: href,
                module: MODULE_ID,
                position: 1,
                creative: image,
            }}
        >
            <div
                className={styles.banner}
                style={{ backgroundColor: bgColor || 'none', minHeight: `${height}px` }}
                data-t-mod={MODULE_ID}
            >
                <Image
                    className={styles.image}
                    src={image}
                    href={href}
                    target={target}
                    alt={alt}
                    width={1920}
                    height={height}
                    background={false}
                    fixed
                />
            </div>
        </Tracker>
    );
};

export default TopStripedBanner;